import React, { useContext, useMemo } from "react";
import Slider from "react-slick";
import MyContext from "../MyContext/MyContext";
import { Link } from "react-router-dom";

const NewArrivalTwo = () => {
  const { data } = useContext(MyContext);

  // Flatten products
  const allProducts = useMemo(() => {
    if (!Array.isArray(data)) return [];
    return data.flatMap((cat) =>
      (cat.products || []).map((p) => ({
        ...p,
        routing_category: cat.routing_category?.toLowerCase(),
      }))
    );
  }, [data]);

  // Shuffle + take 8 random
  const randomProducts = useMemo(() => {
    const shuffled = [...allProducts].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 8);
  }, [allProducts]);

  // Slider settings
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="product py-24 mt-24 mb-24">
      <div className="container container-lg">

        {/* SECTION TITLE */}
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold tracking-tight">
            You Might Also Like
          </h2>
          <p className="text-gray-500 mt-2">
            Recommended products curated specially for you
          </p>
        </div>

        <Slider {...settings}>
          {randomProducts.map((p, index) => {
            const sold = p.sold ?? 18;
            const max = p.max_quantity ?? 35;
            const percent = Math.round((sold / max) * 100);

            return (
              <div key={p.id + "-" + index} className="px-2">
                <div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 shadow-sm hover-shadow-lg">

                  <Link
                    to={`/shop/${p.routing_category}/${p.id}`}
                    className="product-card__cart btn text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 position-absolute inset-block-start-0 inset-inline-end-0 me-16 mt-16"
                  >
                    Add <i className="ph ph-shopping-cart" />
                  </Link>

                  <Link to={`/shop/${p.routing_category}/${p.id}`} className="product-card__thumb flex-center">
                    <img src={p.image} alt={p.title} />
                  </Link>

                  <div className="product-card__content mt-12">
                    <div className="product-card__price mb-16">
                      <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                        ${p.price?.original}
                      </span>
                      <span className="text-heading text-md fw-semibold ">
                        ${p.price?.current}{" "}
                        <span className="text-gray-500 fw-normal">/Qty</span>
                      </span>
                    </div>

                    <div className="flex-align gap-6">
                      <span className="text-xs fw-bold text-gray-600">
                        {p.rating?.stars}
                      </span>
                      <span className="text-15 fw-bold text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                      </span>
                      <span className="text-xs fw-bold text-gray-600">
                        ({p.rating?.reviews_count})
                      </span>
                    </div>

                    <h6 className="title text-lg fw-semibold mt-12 mb-8">
                      <Link
                        to={`/shop/${p.routing_category}/${p.id}`}
                        className="link text-line-2"
                      >
                        {p.title}
                      </Link>
                    </h6>

                    <div className="flex-align gap-4">
                      <span className="text-main-600 text-md d-flex">
                        <i className="ph-fill ph-storefront" />
                      </span>
                      <span className="text-gray-500 text-xs">
                        By {p.details?.Brand || "Unknown Seller"}
                      </span>
                    </div>

                    <div className="mt-12">
                      <div className="progress w-100 bg-color-three rounded-pill h-4">
                        <div
                          className="progress-bar bg-main-600 rounded-pill"
                          style={{ width: `${percent}%` }}
                        />
                      </div>
                      <span className="text-gray-900 text-xs fw-medium mt-8 d-block">
                        Sold: {sold}/{max}
                      </span>
                    </div>

                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default NewArrivalTwo;

